import { Component } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/debounceTime";
import { _UserService } from "../../services/user.service";
import { _UsersService } from "../../services/users.service";
import { _RuleService } from "../../services/rule.service";
import { Router } from "@angular/router";
import { NgRedux } from "@angular-redux/store";
import { PermissionActions } from "../../app.actions";
import { IAppState } from "../../interfaces/appstate.interface";
import { TranslateService } from "@ngx-translate/core";

import { User } from "../../interfaces/user.interface";

declare let $: any;
declare let dialogOpen: any;

@Component({
  selector: "navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
  providers: [_UserService, _UsersService, _RuleService],
})
export class NavbarComponent {
  results: string[];
  headers: any;
  permissions: any = {
    exposure: null,
    rule: null,
    rebalance: null,
    organization: null,
    system: null,
    sysadminSetting: null,
  };
  subscription: any;
  private username: any;

  constructor(
    private user: _UserService,
    private users: _UsersService,
    private rule: _RuleService,
    private active: Router,
    private ngRedux: NgRedux<IAppState>,
    private actions: PermissionActions,
    private translate: TranslateService
  ) {
    this.subscription = Observable.combineLatest([
      ngRedux.select("clientExposure"),
      ngRedux.select("clientRule"),
      ngRedux.select("clientRebalance"),
      ngRedux.select("clientOrganization"),
      ngRedux.select("clientSystem"),
      ngRedux.select("sysadminSetting"),
      ngRedux.select("email"),
    ]).subscribe((res) => {
      this.permissions.exposure = res[0];
      this.permissions.rule = res[1];
      this.permissions.rebalance = res[2];
      this.permissions.organization = res[3];
      this.permissions.system = res[4];
      this.permissions.sysadminSetting = res[5];
      this.username = res[6];
    });
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  ngOnInit() {
    function submitDialogCreate(dialogId, validate, onOK, onCancel) {
      // Create dialog window.
      $(dialogId).jqxWindow({
        autoOpen: false,
        showCloseButton: false,
        width: "400",
        resizable: false,
        isModal: true,
        modalOpacity: 0.3,
        okButton: $(dialogId + " #feedbackSend"),
        cancelButton: $(dialogId + " #feedbackCancel"),
        initContent: function () {
          $(dialogId + " #feedbackSend").jqxButton({
            width: "65px",
          });
          $(dialogId + " #feedbackCancel").jqxButton({
            width: "65px",
          });
          $(dialogId + " #feedbackSend").focus();
          $(dialogId + " #feedbackSend").jqxButton("disabled", true);
        },
      });

      $(dialogId).keyup(function () {
        $(dialogId + " #feedbackSend").jqxButton("disabled", !validate());
      });

      // Set dialog callback on OK.
      $(dialogId).on("close", function (event) {
        event.preventDefault();
        if (event.args.dialogResult.OK) {
          if (onOK !== undefined) onOK();
        } else if (event.args.dialogResult.Cancel) {
          if (onCancel !== undefined) onCancel();
        }
      });
    }

    function simpleDialogCreate(dialogId) {
      // Create dialog window.
      $(dialogId).jqxWindow({
        autoOpen: false,
        showCloseButton: false,
        width: "400",
        resizable: false,
        isModal: true,
        modalOpacity: 0.3,
        okButton: $(dialogId + " #feedbackSent"),
        initContent: function () {
          $(dialogId + " #feedbackSent").jqxButton({
            width: "65px",
          });
          $(dialogId + " #feedbackSent").focus();
        },
      });
    }

    /* We place the create dialog outside of the document.ready() so that it doesn't render */
    submitDialogCreate(
      "#feedbackDialog",
      function () {
        var allValidated = true;
        allValidated = allValidated && $("#body").val().length > 0;
        return allValidated;
      },
      function () {
        var body = $("#body").val();
        body +=
          "\n\n***** Browser Data *****\n" +
          "Page: " +
          window.location.pathname +
          "\n" +
          "Browser: " +
          navigator.appName +
          "; " +
          navigator.product +
          "; " +
          navigator.platform +
          "; " +
          navigator.language +
          "\n" +
          "UserAgent: " +
          navigator.userAgent +
          "\n" +
          "ScreenSize: " +
          screen.width +
          "x" +
          screen.height +
          "\n" +
          "TimezoneOffset: " +
          new Date().getTimezoneOffset() / 60 +
          "\n";

        $.ajax({
          url: "/ajax/support/message",
          type: "POST",
          dataType: "json",
          data: JSON.stringify({
            subject: "User Feedback",
            body: body,
          }),
          contentType: "application/json",
          success: function (data, status, jqXHR) {
            if (jqXHR.status == 201) {
              dialogOpen("#feedbackDialogResult");
            }
          },
        });
      },
      null
    );

    simpleDialogCreate("#feedbackDialogResult");

    function openFeedbackDialog() {
      dialogOpen("#feedbackDialog");
    }

    $(document).ready(function () {
      // set form defaults
      $("#contact").value = $("#httpServletRequest.remoteUser").val();
      var baseUrl = window.location.pathname;

      $("#linkFeedback").click(function () {
        openFeedbackDialog();
        return false;
      });
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/components/navbar/navbar.component.ts